// Small formatting helpers. Numbers use he-IL grouping; the UI renders them in mono/tabular.

const nf = new Intl.NumberFormat('he-IL');
export const fmt = (n: number): string => nf.format(n);

/** Mask a phone for display (own numbers are shown to their tenant, but masked like the mockup). */
export function maskPhone(phone: string | null): string {
  if (!phone) return '—';
  // 972541234567 → 054-123-••••
  const local = phone.replace(/^972/, '0');
  if (local.length < 7) return local;
  return `${local.slice(0, 3)}-${local.slice(3, 6)}-••••`;
}

/** Hebrew relative-ish timestamp from an ISO string. */
export function relTime(iso: string): string {
  const d = new Date(iso);
  const diff = Date.now() - d.getTime();
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const day = 86_400_000;
  if (diff < day && d.getDate() === new Date().getDate()) return `${hh}:${mm}`;
  if (diff < 2 * day) return `אתמול ${hh}:${mm}`;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')} ${hh}:${mm}`;
}

/** Precise absolute timestamp "DD.M.YYYY, HH:MM:SS" (matches the bizz-pilot broadcast feed). */
export function absTime(iso: string): string {
  const d = new Date(iso);
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${d.getMonth() + 1}.${d.getFullYear()}, ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export const SURFACE_LABELS: Record<string, string> = {
  wa_group: 'קבוצת WhatsApp',
  wa_status: 'סטטוס WhatsApp',
  wa_channel: 'ערוץ WhatsApp',
  telegram: 'Telegram',
  x: 'X / Twitter',
};
